// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commutably {
  --fieldset-margin: 0.7em 0 0;
  --fieldset-padding: 1em;
  --fieldset-border: 1px solid var(--color-grey-2);
  --fieldset-border-radius: 6px;
  --fieldset-elevated-background: white;
  --fieldset-elevated-box-shadow: var(--formField-box-shadow);
  --fieldset-elevated-transform: var(--formField-transform);
  --fieldset-legend-gap: 0.4em;
  --fieldset-legend-background: white;
  --fieldset-legend-border-radius: 8px;
  --fieldset-legend-padding: 0.3em 0.5em 0.2em;
  --fieldset-legend-margin: -2.8em 0 0.2em;
  --fieldset-legend-font-size: var(--formField-font-size);
  --fieldset-legend-font-weight: normal;
  --fieldset-legend-border-bottom: 1px solid black;
}
`, "",{"version":3,"sources":["webpack://./src/theme/components/Fieldset.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,gDAAgD;EAChD,6BAA6B;EAC7B,qCAAqC;EACrC,2DAA2D;EAC3D,yDAAyD;EACzD,4BAA4B;EAC5B,mCAAmC;EACnC,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,uDAAuD;EACvD,qCAAqC;EACrC,gDAAgD;AAClD","sourcesContent":[".commutably {\n  --fieldset-margin: 0.7em 0 0;\n  --fieldset-padding: 1em;\n  --fieldset-border: 1px solid var(--color-grey-2);\n  --fieldset-border-radius: 6px;\n  --fieldset-elevated-background: white;\n  --fieldset-elevated-box-shadow: var(--formField-box-shadow);\n  --fieldset-elevated-transform: var(--formField-transform);\n  --fieldset-legend-gap: 0.4em;\n  --fieldset-legend-background: white;\n  --fieldset-legend-border-radius: 8px;\n  --fieldset-legend-padding: 0.3em 0.5em 0.2em;\n  --fieldset-legend-margin: -2.8em 0 0.2em;\n  --fieldset-legend-font-size: var(--formField-font-size);\n  --fieldset-legend-font-weight: normal;\n  --fieldset-legend-border-bottom: 1px solid black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
